import { React, useEffect } from "react";
import AOS from "aos";
import Setup from "../../Assets/Setup.svg";
import MakePayment from "../../Assets/MakePayment.svg";
import GetYourProducts from "../../Assets/getYourProducts.svg";

const HowItWorks = () => {
  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);

  const cards = [
    {
      img: Setup,
      key: 1,
      header: "Setup your Business",
      text: "Setup your business on logistat and instantly receive your admin details.",
    },
    {
      img: MakePayment,
      key: 2,
      header: "Make payment",
      text: "Instead of NGN 5,000,000 for a standard delivery service pay a one-time setup fee of just NGN 20,000.",
    },
    {
      img: GetYourProducts,
      key: 3,
      header: "Get your Products",
      text: "Your rider app, customer app, customer website and admin dashboard will be deployed to you instantly.",
    },
  ];

  const fontSize = {
    fontSize: ".89rem",
    maxWidth: "20rem",
  };
  return (
    <div id="howItWorks" className="container mb-3 text-center">
      <div className="row">
        <h4 className="my-2 fs-3 fw-bold">How It Works</h4>
        {cards.map((card) => {
          return (
            <div
              className="col-12 p-2 col-md-4 text-center my-3"
              key={card.key}
              data-aos="zoom-in"
            >
              <img src={card.img} alt="contactusImg" />
              <h5 className="my-2 fs-6 fw-bold">{card.header}</h5>
              <div className="mx-auto" style={fontSize}>
                {card.text}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HowItWorks;
